import { useRef, useEffect } from 'react';
import gsap from 'gsap';

//* Style
import AboutUsHeroStyle from './style';

//* helpers
import { useActiveSection } from '@/helpers';

//* Components
import Container from '@/components/common/Container';
import Text from '@/components/common/Text';
import Image from '@/components/common/Image';

const AboutUsHero = ({ title, row }) => {
	//! Refs
	const sectionRef = useRef();
	const descriptionRef = useRef();
	const imageRef = useRef();
	const titleRef = useRef();

	//! Active section
	const activeSection = useActiveSection(sectionRef);

	useEffect(() => {
		if (activeSection) {
			gsap.to(titleRef.current, { x: 0, opacity: 1 });
			gsap.to(descriptionRef.current, { x: 0, opacity: 1 });
			gsap.to(imageRef.current, { scale: 1, opacity: 1 });
		}
	}, [activeSection]);

	return (
		<AboutUsHeroStyle ref={sectionRef}>
			<Container
				className={'about-us-hero-container'}
				first
				section>
				<div>
					<Text
						ref={titleRef}
						className={'h1 font-futura-medium about-us-title'}
						text={title}
					/>
				</div>
				<Image
					ref={imageRef}
					className={'about-us-image'}
					src={row.image.src}
					alt={row.image.alt}
				/>
				<div
					className='info'
					ref={descriptionRef}>
					<Text
						tag={'h2'}
						text={row.title}
					/>
					<div dangerouslySetInnerHTML={{ __html: row.description }} />
				</div>
			</Container>
		</AboutUsHeroStyle>
	);
};

export default AboutUsHero;
